import { Skeleton } from "./Skeleton";

interface ListRowsSkeletonProps {
  rows?: number;
}

export function ListRowsSkeleton({ rows = 5 }: ListRowsSkeletonProps) {
  return (
    <ul className="ph-low-stock-list ph-skeleton-list" aria-busy="true" aria-label="Chargement">
      {Array.from({ length: rows }, (_, i) => (
        <li key={i} className="ph-low-stock-item ph-skeleton-list-item">
          <div>
            <Skeleton className="ph-skeleton--list-title" />
            <Skeleton className="ph-skeleton--list-sub" />
          </div>
          <Skeleton className="ph-skeleton--list-value" />
        </li>
      ))}
    </ul>
  );
}
